import { useSelector } from "react-redux";
import FechaPresentacionLabel from "../../../commons/planillas/FechaPresentacionLabel";
import { enumTiposGestion } from "./enumTipoGestion";


const FechaPresentacionObra = () => {
  const identificacion = useSelector(
    (state) => state.obra.postNuevaObra.identificacion
  );
  return (
    <FechaPresentacionLabel
      date={
        identificacion.idTipoAvisoObra !== enumTiposGestion.edicion
          ? new Date()
          : identificacion.fechaRecepcion
      }
    />
  )
}

export default FechaPresentacionObra;